'use client';

import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import { isFilled } from "@prismicio/client";
import { useEffect, useState } from "react";

const BorderSVG = ({ className }) => (
  <svg 
    width="100%" 
    preserveAspectRatio="none" 
    height="1" 
    viewBox="0 0 374 1" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    <path 
      d="M139.692 0.498221C129.631 0.477452 128.124 0.399629 116.601 0.417167C105.078 0.434699 93.5496 0.381238 88.419 0.41326C83.2885 0.445294 82.7467 0.348781 75.461 0.370292C68.176 0.391797 63.7601 0.378333 57.3887 0.346854C51.0163 0.315375 31.4413 0.288653 24.3233 0.327323C17.2053 0.365992 9.08672 0.299294 4.20416 0.283378C2.68329 0.278421 1.48605 0.271881 0.56842 0.264823C0.182643 0.261852 0.00282196 0.255333 6.10352e-05 0.249198C0.000183105 0.241503 0.278778 0.233568 0.778381 0.232596C3.2034 0.227877 6.8279 0.215578 11.1094 0.187674C19.0924 0.135647 19.965 0.192926 30.7452 0.16619C41.5253 0.139454 48.0024 0.086704 60.6866 0.121268C73.3703 0.155827 76.2838 0.0109793 94.1885 0.0929479C112.093 0.174911 113.977 0.0232208 131.819 0.00310418C149.662 -0.017009 172.185 0.0666642 182.94 0.0597448C193.696 0.052824 208.142 0.0348989 223.39 0.054862C238.637 0.0748243 257.46 0.0251035 274.291 0.0607214C291.121 0.0963383 314.916 0.140928 325.909 0.171073C336.902 0.201217 339.582 0.208046 350.162 0.189628C356.244 0.17904 364.623 0.188776 371.7 0.227714C375.262 0.24731 374.455 0.275205 370.87 0.28826C365.628 0.30735 361.324 0.294202 358.623 0.328299C353.226 0.396448 350.931 0.422652 344.117 0.382987C337.304 0.343331 334.093 0.4334 330.121 0.423026C326.149 0.412645 326.214 0.359606 306.019 0.400565C285.822 0.441528 274.75 0.452255 267.102 0.462089C259.453 0.471922 243.483 0.424927 231.019 0.441581C218.554 0.458234 193.213 0.443613 182.998 0.470878C172.784 0.498141 172.762 0.438694 164.508 0.405448C156.253 0.372202 149.754 0.518991 139.692 0.498221Z" 
      fill="#37393A" 
    />
  </svg>
);

const VerticalBorderSVG = ({ className }) => (
  <svg 
    width="1" 
    preserveAspectRatio="none" 
    height="100%" 
    viewBox="0 0 1 417" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    <path 
      d="M0.993747 146.976C1.03397 166.869 0.86663 191.981 0.880468 203.974C0.89431 215.966 0.929184 232.073 0.889259 249.073C0.849335 266.074 0.950731 287.061 0.879496 305.827C0.808262 324.593 0.718107 351.124 0.657819 363.381C0.597533 375.637 0.583872 378.625 0.620711 390.422C0.641886 397.203 0.622412 406.545 0.54454 414.436C0.505347 418.407 0.450533 417.507 0.424423 413.51C0.386248 407.665 0.411552 402.867 0.343367 399.855C0.20707 393.837 0.154662 391.279 0.233992 383.682C0.313308 376.085 0.133165 372.505 0.153913 368.076C0.174674 363.648 0.280756 363.72 0.198834 341.202C0.116908 318.684 0.0964291 306.339 0.0767613 297.812C0.0570931 289.284 0.149132 271.477 0.115822 257.579C0.0825148 243.681 0.112734 215.427 0.0582025 204.037C0.00368045 192.648 0.12257 192.624 0.189061 183.421C0.255541 174.217 -0.0380248 166.971 0.00351293 155.753C0.0450539 144.535 0.200696 142.855 0.165621 130.007C0.130553 117.16 0.237473 104.306 0.173432 98.585C0.109367 92.8649 0.30336 92.2607 0.260346 84.1377C0.217331 76.0149 0.242309 71.0914 0.305267 63.9873C0.368225 56.8828 0.421667 35.0569 0.344328 27.1201C0.266985 19.1834 0.401366 10.1305 0.433194 4.68652C0.443107 2.99105 0.457165 1.65679 0.47128 0.633789C0.477218 0.203794 0.489288 0.00327168 0.501553 2.17878e-08C0.516938 0.000193292 0.532806 0.310449 0.534756 0.867188C0.544195 3.57103 0.568792 7.61285 0.6246 12.3867C0.728653 21.2875 0.613122 22.2608 0.666594 34.2803C0.720067 46.2995 0.827515 53.5209 0.758392 67.6631C0.68927 81.8054 0.977994 85.0542 0.814058 105.018C0.650131 124.98 0.953516 127.082 0.993747 146.976Z" 
      fill="#37393A" 
    />
  </svg>
);

const ImageFrame = ({ children, isMobile = false }) => (
  <div className={`${isMobile ? 'h-97 max-h-[50dvh]' : 'h-[70dvh] min-h-150'} w-full relative`}>
    <BorderSVG className={`absolute absolute-x-center ${isMobile ? 'w-[calc(100%+50px)]' : 'w-[calc(100%+100px)]'} bottom-0 z-110`} />
    <BorderSVG className={`absolute absolute-x-center ${isMobile ? 'w-[calc(100%+50px)]' : 'w-[calc(100%+100px)]'} top-0 z-110`} />
    <VerticalBorderSVG className={`absolute absolute-y-center right-0 ${isMobile ? 'h-[calc(100%+40px)]' : 'h-[calc(100%+90px)]'} z-110`} />
    <VerticalBorderSVG className={`absolute absolute-y-center left-0 ${isMobile ? 'h-[calc(100%+40px)]' : 'h-[calc(100%+90px)]'} z-110`} />
    {children}
  </div>
);

/**
 * @typedef {import("@prismicio/client").Content.HomepageIntroSlice} HomepageIntroSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HomepageIntroSlice>} HomepageIntroProps
 * @type {import("react").FC<HomepageIntroProps>}
 */
const HomepageIntro = ({ slice, context }) => {
  const [hasEntered, setHasEntered] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  // Gestion du blocage du scroll
  useEffect(() => {
    const bodyStyle = document.body.style;

    if (!hasEntered && !context?.hasSeenIntro) {
      bodyStyle.overflow = 'hidden';
      bodyStyle.position = 'fixed';
      bodyStyle.width = '100%';
      bodyStyle.height = '100%';
    } else {
      bodyStyle.overflow = '';
      bodyStyle.position = '';
      bodyStyle.width = '';
      bodyStyle.height = '';
    }

    return () => {
      bodyStyle.overflow = '';
      bodyStyle.position = '';
      bodyStyle.width = '';
      bodyStyle.height = '';
    };
  }, [hasEntered, context?.hasSeenIntro]);

  const handleEnter = () => {
    setIsFadingOut(true);
    // Créer un cookie de session (expire à la fermeture du navigateur)
    document.cookie = 'hasSeenIntro=true; path=/; SameSite=Lax';
    setTimeout(() => {
      setHasEntered(true);
      // Émettre un événement custom pour notifier les autres composants
      window.dispatchEvent(new CustomEvent('homepageIntroHidden'));
    }, 1000); // Durée de l'animation fade-out
  };

  // Si l'intro a déjà été vue (vérification côté serveur), ne rien afficher
  if (context?.hasSeenIntro || hasEntered) {
    return null;
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`fixed z-150 h-screen w-screen top-0 bg-beige flex items-center justify-center transition-opacity duration-1000 ${isFadingOut ? 'opacity-0' : 'opacity-100'}`}
    >
      <div className="max-w-400 mx-auto w-full">
        <div className="flex flex-col lg:flex-row px-8 md:px-16 gap-12 md:justify-between md:items-center">
          
          {/* Image mobile */}
          <div className="lg:hidden w-full">
            <ImageFrame isMobile>
              {isFilled.image(slice.primary.img_mobile) && (
                <div className="w-full h-full relative overflow-visible z-100">
                  <PrismicNextImage
                    field={{
                      ...slice.primary.img_mobile,
                      alt: slice.primary.img_mobile.alt || "Image d'illustration mobile"
                    }}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              )}
            </ImageFrame>
          </div>

          {/* Contenu textuel */}
          <div className="flex flex-col gap-10 lg:max-w-130 xl:max-w-170 w-full h-auto lg:justify-center">
            {isFilled.richText(slice.primary.title) && (
              <PrismicRichText field={slice.primary.title} />
            )}

            <a
              className="text-center !font-normal md:text-start 2xl:text-center cta-text 2xl:text-3xl cursor-pointer"
              onClick={handleEnter}
            >
              {isFilled.keyText(slice.primary.cta) ? slice.primary.cta : "Entrer"}
            </a>
          </div>

          {/* Image desktop */}
          <div className="hidden lg:block flex-1 md:max-w-113 xl:max-w-150">
            <ImageFrame>
              {isFilled.image(slice.primary.img) && (
                <div className="w-full h-full relative overflow-visible z-100">
                  <PrismicNextImage
                    field={{
                      ...slice.primary.img,
                      alt: slice.primary.img.alt || "Image d'illustration"
                    }}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              )}
            </ImageFrame>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomepageIntro;
